import { MULTI_FORMULA_COMBINATIONS } from '@mobi/betslip/helpers/constants'
import { getBetsInMulti } from '@mobi/betslip/helpers/state'
import { BetSlipItem, Campaign, FobBetReceiptResponse, MultiInvestment } from '@mobi/betslip/types'

export const getItemsWithBonusesApplied = (
  betItems: BetSlipItem[],
  bonusCashCampaign: Campaign[],
  multiInvestment: MultiInvestment,
  multiReceipt?: FobBetReceiptResponse
) => {
  const clonedCampaigns = bonusCashCampaign.map(campaign => ({
    ...campaign,
  }))

  const updatedItems = betItems.map(item => {
    const newItem = { ...item }
    const appliedBonusBet = { campaignId: 0, value: 0 }
    let updatedCampaign = undefined

    const totalInvestment = item.investment.bonusBet?.value || 0

    if (
      (item.investment.win.isBonusBet || item.investment.place.isBonusBet) &&
      item.investment.bonusBet
    ) {
      appliedBonusBet.campaignId = item.investment.bonusBet.campaignId
      appliedBonusBet.value = item.investment.bonusBet.value
      updatedCampaign = item?.campaign
    }

    if (item.investment.win.isBonusCash && item.investment.place.isBonusCash) {
      const campaignIndex = clonedCampaigns.findIndex(c => c.remainingAmount > 0)
      updatedCampaign = clonedCampaigns[campaignIndex]

      if (campaignIndex !== -1) {
        const campaign = clonedCampaigns[campaignIndex]

        if (totalInvestment >= campaign.remainingAmount) {
          appliedBonusBet.campaignId = campaign.id
          appliedBonusBet.value = campaign.remainingAmount
          clonedCampaigns[campaignIndex] = {
            ...campaign,
            remainingAmount: 0,
          }
        } else {
          appliedBonusBet.campaignId = campaign.id
          appliedBonusBet.value = item.investment.win.value + item.investment.place.value
          clonedCampaigns[campaignIndex] = {
            ...campaign,
            remainingAmount: campaign.remainingAmount - totalInvestment,
          }
        }
      }
    }

    newItem.investment = { ...newItem.investment, bonusBet: appliedBonusBet }
    newItem.campaign = updatedCampaign
    return newItem
  })

  const selectedMultiItems = getBetsInMulti(betItems)

  if (clonedCampaigns.length > 0) {
    const factorKeys: (keyof Pick<MultiInvestment, 'f1' | 'f2' | 'f3' | 'f4' | 'f5'>)[] = [
      'f1',
      'f2',
      'f3',
      'f4',
      'f5',
    ]

    const hasNonZeroFactor = factorKeys.some(key => Number(multiInvestment[key] ?? 0) > 0)

    if (hasNonZeroFactor) {
      const campaignIndex = clonedCampaigns.findIndex(c => c.remainingAmount > 0)
      const campaign = clonedCampaigns[campaignIndex]

      let remainingAmount = !multiReceipt ? campaign.remainingAmount : multiReceipt.bonusBet

      const newInvestment = { ...multiInvestment }

      newInvestment.isBonusCash = true
      newInvestment.bonusBetId = campaign.id

      newInvestment.value = Math.min(newInvestment.value, remainingAmount)
      remainingAmount -= newInvestment.value
      for (const key of factorKeys) {
        const combos = MULTI_FORMULA_COMBINATIONS[key]
        const legCount = selectedMultiItems.length
        const comboCount = combos[`${legCount}`]

        const factorValue = Number(newInvestment[key] ?? 0) * comboCount
        if (factorValue > 0) {
          const assignAmount = Math.min(factorValue, remainingAmount)
          newInvestment[key] = assignAmount
          remainingAmount -= assignAmount
        }
      }

      return {
        betSlipItems: updatedItems,
        remainingBonusCashCampaigns: clonedCampaigns,
        betSlipMultiInvestment: newInvestment,
      }
    }
  }

  return {
    betSlipItems: updatedItems,
    remainingBonusCashCampaigns: clonedCampaigns,
    betSlipMultiInvestment: multiInvestment,
  }
}
